import { useEffect, useState } from "react";

import {
    Link
} from "react-router-dom";

import { getPortfolios } from "../api";


function PortfolioList() {

    const [portfolios, setPortfolios] = useState([]);

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchData();
    }, []);

    async function fetchData() {

        try {

            const data = await getPortfolios();

            setPortfolios(data);

        } catch (error) {

            console.error(error);

        } finally {

            setLoading(false);

        }
    }

    if (loading) {

        return (
            <div className="container mt-5 text-center">
                <h3>Loading...</h3>
            </div>
        );
    }

    return (
        <div>

            {/* Navbar */}
            <nav className="navbar navbar-expand-lg navbar-dark bg-dark shadow">

                <div className="container">

                    <Link
                        className="navbar-brand fw-bold"
                        to="/"
                    >
                        Rifhandi Portfolio
                    </Link>

                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarNav"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div
                        className="collapse navbar-collapse"
                        id="navbarNav"
                    >

                        <ul className="navbar-nav ms-auto">

                            <li className="nav-item">
                                <Link
                                    className="nav-link active"
                                    to="/"
                                >
                                    Portfolio
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link
                                    className="nav-link"
                                    to="/tentang"
                                >
                                    Tentang
                                </Link>
                            </li>

                        </ul>

                    </div>

                </div>

            </nav>

            {/* Hero */}
            <div className="hero-section text-center d-flex align-items-center">

                <div className="container">

                    <h1 className="display-4 fw-bold">
                        Selamat Datang 👋
                    </h1>

                    <p className="lead mt-3">
                        Salam hangat untuk para pengunjung.
                        Terima kasih telah mengunjungi
                        website portfolio saya.
                    </p>

                </div>

            </div>

            {/* Portfolio */}
            <div className="container py-5">

                <h2 className="text-center fw-bold mb-5">
                    My Portfolio
                </h2>

                <div className="row">

                    {portfolios.map((item) => (

                        <div
                            className="col-md-4 mb-4"
                            key={item.id}
                        >

                            <div className="card border-0 shadow-lg h-100 portfolio-card">

                                <div className="text-center pt-4">

                                    <img
                                        src={
                                            item.image ||
                                            "/image/cv.png"
                                        }
                                        alt={item.title}
                                        className="rounded-circle"
                                        style={{
                                            width: "120px",
                                            height: "120px",
                                            objectFit: "cover"
                                        }}
                                    />

                                </div>

                                <div className="card-body text-center">

                                    <h5 className="fw-bold">
                                        {item.title}
                                    </h5>

                                    <p className="text-muted">
                                        {item.description}
                                    </p>

                                    <div className="mb-3">

                                        {item.tech_stack?.map((tech, index) => (

                                            <span
                                                key={index}
                                                className="badge bg-primary me-2 mb-2"
                                            >
                                                {tech}
                                            </span>

                                        ))}

                                    </div>

                                    <Link
                                        to={`/portfolio/${item.id}`}
                                        className="btn btn-dark"
                                    >
                                        Detail Project
                                    </Link>

                                </div>

                            </div>

                        </div>

                    ))}

                </div>

            </div>

            {/* Footer */}
            <footer className="bg-dark text-light py-5">

                <div className="container text-center">

                    <h4 className="fw-bold mb-3">
                        Rifhandi
                    </h4>

                    <p className="text-muted">
                        Fullstack Developer • Backend • Frontend • Cloud
                    </p>

                    <div className="d-flex justify-content-center gap-3 flex-wrap mb-4">

                        <a
                            href="https://wa.me/6281927067602"
                            className="btn btn-success"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            WhatsApp
                        </a>

                        <a
                            href="https://github.com/muhammad-rifqi/"
                            className="btn btn-light"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            GitHub
                        </a>

                        <a
                            href="https://www.youtube.com/@muhammadrifqi9805"
                            className="btn btn-danger"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Youtube
                        </a>

                        <a
                            href="https://www.linkedin.com/in/muhammad-rifqy-004b47107"
                            className="btn btn-primary"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            LinkedIn
                        </a>

                    </div>

                    <hr />

                    <p className="mb-0">
                        © 2026 Copyright by Rifhandi
                    </p>

                </div>

            </footer>

            {/* Floating WA */}
            <a
                href="https://wa.me/6281927067602"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    position: "fixed",
                    width: "60px",
                    height: "60px",
                    bottom: "20px",
                    right: "20px",
                    backgroundColor: "#25D366",
                    color: "#fff",
                    borderRadius: "50%",
                    textAlign: "center",
                    fontSize: "30px",
                    boxShadow: "2px 2px 10px rgba(0,0,0,0.3)",
                    zIndex: 1000,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textDecoration: "none"
                }}
            >
                💬
            </a>
        </div>
    );
}

export default PortfolioList;